import api from './api';
import { Company } from '../types/index';

export const companiesService = {
  async getAll(): Promise<Company[]> {
    const response = await api.get('/companies');
    return response.data.data;
  },

  async getById(id: string): Promise<Company> {
    const response = await api.get(`/companies/${id}`);
    return response.data.data;
  },

  async create(companyData: Partial<Company>): Promise<Company> {
    const response = await api.post('/companies', companyData);
    return response.data.data;
  },

  async update(id: string, companyData: Partial<Company>): Promise<Company> {
    const response = await api.put(`/companies/${id}`, companyData);
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/companies/${id}`);
  },
};
